import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class RutasService {

  constructor(private http: HttpClient) { }

  public obtenerListaRutas(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"rutas/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public guardarRuta(ruta){
    return this.http.post(GlobalVariable.API_SERVER_URL+"rutas",ruta,GlobalVariable.httpOptions);
  }

  public actualizarRuta(ruta){
    return this.http.put(GlobalVariable.API_SERVER_URL+"rutas/"+ruta.id,ruta,GlobalVariable.httpOptions);
  }

  public obtenerRuta(id_ruta){
    return this.http.get(GlobalVariable.API_SERVER_URL+"rutas/"+id_ruta,GlobalVariable.httpOptions);
  }

  public eliminarRuta(ruta){
    return this.http.delete(GlobalVariable.API_SERVER_URL+"rutas/"+ruta.id,GlobalVariable.httpOptions);
  }
}
